import { SecureStorage, KeychainAccess, StorageErrorType } from "@aparajita/capacitor-secure-storage";
import { backendUrl, isNative } from "@/lib/mobile";

const KEY = "procrypto.auth-session.v1";
const WEB_KEY = "procrypto.web-session.v1";

// On web (non-native) we store the JWT in sessionStorage so it survives
// page refreshes without relying on cross-origin cookies, which browsers
// block when frontend and backend run on different origins in development.
export async function readNativeSession() {
  if (!isNative) {
    try { return sessionStorage.getItem(WEB_KEY) || ""; } catch { return ""; }
  }
  let stored;
  try { stored = await SecureStorage.get(KEY, false, false); }
  catch (error) {
    if (error.code !== StorageErrorType.invalidData) throw error;
    await SecureStorage.remove(KEY, false);
    return "";
  }
  if (!stored) return "";
  // A test-server change must never send one server's credentials to another.
  if (stored.origin !== backendUrl() || typeof stored.token !== "string") {
    await SecureStorage.remove(KEY, false);
    return "";
  }
  return stored.token;
}

export async function writeNativeSession(token) {
  if (!isNative) {
    try {
      if (token) sessionStorage.setItem(WEB_KEY, token);
      else sessionStorage.removeItem(WEB_KEY);
    } catch {}
    return;
  }
  if (token) {
    await SecureStorage.set(KEY, { origin: backendUrl(), token }, false, false,
      KeychainAccess.whenUnlockedThisDeviceOnly);
  } else await SecureStorage.remove(KEY, false);
}
